import { createContext, useContext, useRef } from 'react';

const Context = createContext<Record<string, any> | undefined>(undefined);

export const TempDataContextProvider = ({ children }) => {
	const data = useRef({});
	return <Context.Provider value={data.current}>{children}</Context.Provider>;
};

export const TempDataContextRefProvider = ({ data, children }) => {
	return <Context.Provider value={data}>{children}</Context.Provider>;
};

export function useTempDataContext<T = Record<string, any>>() {
	return useContext(Context) as T;
}

Context.displayName = 'TempDataContext';
